<template>
    <div>
        <h5 class="title is-5 has-text-primary">
            {{ $t("connected-users.title") }} - {{ usersCount }}
        </h5>
        <div v-if="isLoading">
            <Loading />
        </div>
        <div v-else>
            <div v-if="haveUsers" class="users-container">
                <template v-for="user in users">
                    <ConnectedUser :user="user" :key="user.id" />
                </template>
            </div>
            <div v-else>
                <p>{{ $t("connected-users.empty-users") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import ConnectedUser from "./ConnectedUser";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "connected-users",
    components: {
        ConnectedUser,
        Loading,
    },
    data() {
        return {
            isLoading: true,
            users: [],
        };
    },
    mounted() {
        this.retrieveUsers();
    },
    computed: {
        haveUsers() {
            return this.users.length > 0;
        },
        usersCount() {
            return this.users.length;
        },
    },
    methods: {
        async retrieveUsers() {
            this.isLoading = true;

            let response = await RepositoryFactory.dashboard.getActiveUsers({
                take: 10,
            });
            this.users = response.data.items;

            this.isLoading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.users-container {
    max-height: 32vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>